{
  "version": 1,
  "asset_id": "6b261a93-4f8e-45a5-8e55-5e9a808ba380",
  "project_id": "160b2239-3b67-4000-8b6e-d774982b0968",
  "url": "/__l5e/assets-v1/6b261a93-4f8e-45a5-8e55-5e9a808ba380/dr-sara-instagram-1m.jpg",
  "r2_key": "a/v1/160b2239-3b67-4000-8b6e-d774982b0968/6b261a93-4f8e-45a5-8e55-5e9a808ba380/dr-sara-instagram-1m.jpg",
  "original_filename": "dr-sara-instagram-1m.jpg",
  "size": 71891,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T07:26:52Z"
}
